<template>
  <div>
    <va-modal
      v-model="showModal"
      id="leadDetailsModal"
      ref="leadDetailsModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="false"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      :fixedLayout="true">

      <div slot="header" class="d-flex justify--space-between">
          <span :class="{'col-width': isMobile}">
            <span><b style="font-size:22px; margin-bottom: 1rem; font-weight: bold"
                     class="mr-2"> {{ headerTitle | capitalize }}</b></span>
          </span>

        <va-popover
          placement="top"
          :message="selectedLead.person.email === null ? $t('dashboard_new_evollu.send_pdf_no_email') : $t('dashboard_new_evollu.send_pdf')">
          <va-button large icon="fa fa-envelope" color="#29C4AA" @click.prevent="sendReportEmail()"
                     :disabled="isSendingReportEmail || selectedLead.person.email === null"></va-button>
        </va-popover>

        <span class="close-modal-button" v-if="isMobile">
          <va-button icon="fa fa-times" @click.prevent="$emit('cancel')"></va-button>
        </span>
      </div>

      <!-- Person information -->
      <div class="row">
        <h3>{{ $t('evohealth.patient.details_title') }}</h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.name') }}:
            </span>
          {{ selectedLead.person ? selectedLead.person.name ? selectedLead.person.name : 'N/A' : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.phone') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.mobilePhone ? selectedLead.person.mobilePhone : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.email') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.email ? selectedLead.person.email : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.birthdate') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.birthdate ? moment.utc(selectedLead.person.birthdate).locale('pt').local().format('YYYY-MM-DD') : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.gender') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.gender ? $t(`genders.${selectedLead.person.gender}`) : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.tax_nr') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.taxNr ? selectedLead.person.taxNr : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3" v-if="selectedLead.person && selectedLead.person.healthNr">
            <span class="is-bold">
              {{ $t('people_manager.health_nr') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.healthNr ? selectedLead.person.healthNr : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.address') }}:
            </span>
          {{ handleAddress() }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.country') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.country ? countries.find(elem => elem.code === selectedLead.person.country.toUpperCase()).name : 'N/A'
          }}
        </div>
      </div>

      <hr class="separator-lead-details">

      <div class="row">
        <h3>{{ $t('biosigns.lead_details_title') }}</h3>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('biosigns.columns.entity') }}:
            </span>
          {{ selectedLead.entity ? selectedLead.entity.name : 'N/A' }}
        </div>

        <!--<div v-for="healthParam in visibleHealthParams" class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t(`biosigns.columns.${healthParam.name}`)}}:
            </span>
          {{ extractValue(healthParam) }}
        </div>-->
      </div>
      <div v-if="data !== null">
        <div class="row col-12" v-for="area in Object.keys(data)">
          <div v-if="area !== 'Unknown'" class="col-12">
            <div style="background-color: #ededed; border-radius: 6px" class="pt-2 pb-1 pl-2">
              <h4>{{ $t(`evohealth.health_areas.parameters_${area}`) }}</h4>
            </div>
            <div class="grid-container mt-3">
              <va-card v-for="value in data[area]" :key="value.id" class="measurement-card">
                <div>
                  <div class="left-div text-center">
                    <span v-if="Object.keys(iconsMapping).includes(value.healthParam.name)" style="font-size: 35px;"
                          :style="{color: value.conditionParameter ? value.conditionParameter.color : '#6E6E6E'}"
                          :class="iconsMapping[value.healthParam.name]" />
                    <span class="text--bold pt-2" v-if="value.conditionParameter"
                          :style="{color: value.conditionParameter ? value.conditionParameter.color : '#6E6E6E'}"> {{ $t(`evohealth.biosigns.conditions.${value.conditionParameter.type.toLowerCase()}`) }} </span>
                  </div>
                  <div class="right-div">
                    <div class="col-12 text-center font-weight-bold">
                      {{ $t(`biosigns.columns.${value.healthParam.name}`) }}
                    </div>
                    <div class="col-12 text-center mt-2"
                         :style="{color: value.conditionParameter ? value.conditionParameter.color : '#6E6E6E'}">
                      {{ extractValue(value.healthParam) }}
                    </div>
                  </div>
                </div>

              </va-card>
            </div>
          </div>
        </div>
        <div v-if="selectedLead.recommendations">
          <hr class="separator-lead-details mb-4">
          <va-card>
            <h3> {{ $t('evohealth.recommendations') }} </h3>
            <span>{{ getRecommendation(selectedLead.recommendations) }}</span>
          </va-card>
        </div>
      </div>

      <IframeSessionStats :iframeSessionId="selectedLead.iframeSessionId" />

      <!--Lead Device Info-->
      <div v-if="additionalDeviceInfoJson">
        <div class="row">
          <h3>{{ $t('dashboard_new_evollu.device_info_modal.title') }}</h3>
        </div>

        <div class="row">
          <span class="is-bold" style="font-size: 17px">
            {{ $t('evohealth.biosigns.leadDetails.deviceInfo.signalQuality') }}
          </span>
        </div>
        <div class="row evollu-form mt-2">
          <div class="col-12">
            <label class="is-bold mb-0"> {{ $t('evohealth.biosigns.leadDetails.deviceInfo.hrHrv') }}:
              <label class="pl-1" style="font-weight: normal" :style="{color: additionalDeviceInfoJson.signalQuality.hr_hrv ? additionalDeviceInfoJson.signalQuality.hr_hrv > 0.7 ? '#5ca93f' : '#b61f1f' : '#6E6E6E' }"> {{additionalDeviceInfoJson.signalQuality.hr_hrv}}
                <va-popover placement="top" :message="`0-1. ${$t('evohealth.biosigns.leadDetails.deviceInfo.goodAboveOf', {quality: '0.7'})}`"><i style="color: #6E6E6E" class="fa fa-info-circle pl-1"></i> </va-popover>
              </label>
            </label>
          </div>
          <div class="col-12">
            <label class="is-bold mb-0"> {{ $t('evohealth.biosigns.leadDetails.deviceInfo.bp') }}:
              <label class="pl-1" style="font-weight: normal" :style="{color: additionalDeviceInfoJson.signalQuality.bp ? additionalDeviceInfoJson.signalQuality.bp > 0.6 ? '#5ca93f' : '#b61f1f' : '#6E6E6E' }"> {{additionalDeviceInfoJson.signalQuality.bp}}
                <va-popover placement="top" :message="`0-1. ${$t('evohealth.biosigns.leadDetails.deviceInfo.goodAboveOf', {quality: '0.6'})}`"><i style="color:#6E6E6E;" class="fa fa-info-circle pl-1"></i> </va-popover>
              </label>
            </label>
          </div>
          <div class="col-12">
            <label class="is-bold mb-0"> {{ $t('biosigns.columns.respiratoryRate') }}:
              <label class="pl-1" style="font-weight: normal" :style="{color: additionalDeviceInfoJson.signalQuality.resp ? additionalDeviceInfoJson.signalQuality.resp > 0.9 ? '#5ca93f' : '#b61f1f' : '#6E6E6E' }"> {{additionalDeviceInfoJson.signalQuality.resp}}
                <va-popover placement="top" :message="`0-1. ${$t('evohealth.biosigns.leadDetails.deviceInfo.goodAboveOf', {quality: '0.9'})}`"><i style="color:#6E6E6E;" class="fa fa-info-circle pl-1"></i> </va-popover>
              </label>
            </label>
          </div>
          <div class="col-12">
            <label class="is-bold mb-0"> {{ $t('biosigns.columns.oxygenSaturation') }}:
              <label class="pl-1" style="font-weight: normal" :style="{color: additionalDeviceInfoJson.signalQuality.spo2 ? additionalDeviceInfoJson.signalQuality.spo2 > 0.9 ? '#5ca93f' : '#b61f1f' : '#6E6E6E' }"> {{additionalDeviceInfoJson.signalQuality.spo2}}
                <va-popover placement="top" :message="`0-1. ${$t('evohealth.biosigns.leadDetails.deviceInfo.goodAboveOf', {quality: '0.9'})}`"><i style="color:#6E6E6E;" class="fa fa-info-circle pl-1"></i> </va-popover>
              </label>
            </label>
          </div>
        </div>

        <div class="row mt-3">
          <span class="is-bold" style="font-size: 17px">
            {{ $t('evohealth.biosigns.leadDetails.deviceInfo.imageQualityTitle') }}
          </span>
        </div>
        <div class="row evollu-form mt-2">
          <div class="col-12">
            <label class="is-bold mb-0"> {{ $t('evohealth.biosigns.leadDetails.deviceInfo.imageQuality.brightness') }}:
              <label class="pl-1" style="font-weight: normal" :style="{color: additionalDeviceInfoJson.imageQuality.brightness ? additionalDeviceInfoJson.imageQuality.brightness > 0.7 ? '#5ca93f' : '#983333' : '#6E6E6E' }"> {{additionalDeviceInfoJson.imageQuality.brightness}}
                <va-popover placement="top" :message="`0-1. ${$t('evohealth.biosigns.leadDetails.deviceInfo.goodAboveOf', {quality: '0.7'})}`"><i class="fa fa-info-circle pl-1" style="color: #6E6E6E"></i> </va-popover>
              </label>
            </label>
          </div>
          <div class="col-12 ">
            <label class="is-bold mb-0"> {{ $t('evohealth.biosigns.leadDetails.deviceInfo.imageQuality.contrast') }}:
              <label class="pl-1" style="font-weight: normal" :style="{color: additionalDeviceInfoJson.imageQuality.contrast ? additionalDeviceInfoJson.imageQuality.contrast > 0.7 ? '#5ca93f' : '#b61f1f' : '#6E6E6E' }"> {{additionalDeviceInfoJson.imageQuality.contrast}}
                <va-popover placement="top" :message="`0-1. ${$t('evohealth.biosigns.leadDetails.deviceInfo.goodAboveOf', {quality: '0.7'})}`"><i class="fa fa-info-circle pl-1" style="color:#6E6E6E;"></i> </va-popover>
              </label>
            </label>
          </div>
          <div class="col-12">
            <label class="is-bold mb-0"> {{ $t('evohealth.biosigns.leadDetails.deviceInfo.imageQuality.motion') }}:
              <label class="pl-1" style="font-weight: normal" :style="{color: additionalDeviceInfoJson.imageQuality.motion ? additionalDeviceInfoJson.imageQuality.motion > 0.9 ? '#5ca93f' : '#b61f1f' : '#6E6E6E' }"> {{additionalDeviceInfoJson.imageQuality.motion}}
                <va-popover placement="top" :message="`0-1. ${$t('evohealth.biosigns.leadDetails.deviceInfo.goodAboveOf', {quality: '0.9'})}`"><i class="fa fa-info-circle pl-1" style="color:#6E6E6E;"></i> </va-popover>
              </label>
            </label>
          </div>
        </div>

        <div class="row mt-3">
          <span class="is-bold" style="font-size: 17px">
            {{$t('evohealth.biosigns.leadDetails.deviceInfo.faceLoss')}}
          </span>
        </div>
        <div class="row evollu-form mt-2">
          <div class="col-12">
            <label class="is-bold mb-0"> {{ $t('evohealth.biosigns.leadDetails.deviceInfo.missedFrames') }}:
              <label class="pl-1" style="font-weight: normal"> {{additionalDeviceInfoJson.faceLoss}}

              </label>
            </label>
          </div>
        </div>
      </div>
      <hr class="separator-lead-details">
    </va-modal>
  </div>
</template>

<script>
import moment from 'moment';
import * as countries from 'i18n-iso-countries';
import Vue from 'vue';
import IframeSessionStats from '@/components/evohealth/leads/biosigns/IframeSessionStats.vue';
import { EvohealthService } from '@/api/EvohealthService';

const BIOSIGNS_HEALTH_GROUP_ID = 1;
export default {
  components: { IframeSessionStats },
  props: {
    selectedLead: {
      type: Object,
      required: true,
    },
    healthParams: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      showModal: false,
      data: {},
      iconsMapping: {
        heartRate: 'fa-solid fa-heart-pulse',
        heartRateVariability: 'fa-solid fa-heart-pulse',
        systolicBloodPressure: 'fa-solid fa-heart-pulse',
        diastolicBloodPressure: 'fa-solid fa-heart-pulse',
        oxygenSaturation: 'fa-solid fa-lungs',
        respiratoryRate: 'fa-solid fa-lungs',
        sleep: 'fa-solid fa-bed-pulse',
        equilibrium: 'fa-solid fa-scale-unbalanced',
        stressIndex: 'fa-solid fa-brain',
        health: 'fa-solid fa-heart',
        activity: 'fa-solid fa-person-running',
        metabolism: 'fa-solid fa-fire-flame-curved',
        relaxation: 'fa-solid fa-spa',
        hba1c: 'fa-solid fa-droplet',
        cholesterol: 'fa-solid fa-droplet',
        hemoglobin: 'fa-solid fa-droplet',
      },
      isSendingReportEmail: false,
      deviceInfo: null,
      additionalDeviceInfoJson: null
    };
  },
  mounted() {
    this.showModal = true;

    const groupedByHealthArea = {};

    this.selectedLead.values.forEach(value => {
      value.leadValues.forEach(leadValue => {
        if (this.hiddenParams.includes(leadValue.healthParam.name)) return;
        const healthArea = leadValue.healthParam.healthArea;
        const healthAreaName = healthArea ? healthArea.name : 'Unknown';

        if (!groupedByHealthArea[healthAreaName]) {
          groupedByHealthArea[healthAreaName] = [];
        }

        groupedByHealthArea[healthAreaName].push(leadValue);

        if(this.deviceInfo === null && leadValue.deviceInfo !== null && leadValue.deviceInfo !== "") {
          this.deviceInfo = leadValue.deviceInfo;
          try {
            this.additionalDeviceInfoJson = JSON.parse(this.deviceInfo.additionalInfo)
          } catch (e) {
            console.error('Invalid JSON in deviceInfo.additionalInfo:', e)
            this.additionalDeviceInfoJson = null
          }
        }
      });
    });

    this.data = groupedByHealthArea;



  },
  methods: {
    sendReportEmail: async function() {
      try {
        this.isSendingReportEmail = true
        await EvohealthService.sendReportEmail(this.selectedLead.id, BIOSIGNS_HEALTH_GROUP_ID)
        this.showToast(this.$t('dashboard_new_evollu.pdf_sent_successfully'), this.$store.state.successToastOptions)
      } catch (err) {
        console.log(err)
        this.showToast(this.$t('dashboard_new_evollu.pdf_not_sent'), this.$store.state.errorToastOptions)
      } finally {
        this.isSendingReportEmail = false
      }

    },
    getRecommendation: function(recommendations) {
      const consideredRecommendation = recommendations.find(rec => rec.healthGroup.id === BIOSIGNS_HEALTH_GROUP_ID);
      if (!consideredRecommendation) {
        return 'N/A';
      }
      if (this.$i18n.locale() === 'pt') {
        return consideredRecommendation.textPt;
      } else if (this.$i18n.locale() === 'en') {
        return consideredRecommendation.textEn;
      } else if (this.$i18n.locale() === 'es') {
        return consideredRecommendation.textEs;
      }

      return 'N/A';
    },
    handleAddress: function() {
      let addressStr = '';
      if (this.selectedLead.person) {
        if (this.selectedLead.person && this.selectedLead.person.addressLine) {
          addressStr += this.selectedLead.person.addressLine + ' ';
        }
        if (this.selectedLead.person.country.toLowerCase() === 'pt') {
          if (this.selectedLead.person.concelho) {
            addressStr += this.selectedLead.person.concelho.name;
          }
          if (this.selectedLead.person.concelho && this.selectedLead.person.concelho.distrito) {
            addressStr += ', ' + this.selectedLead.person.concelho.distrito.name + ' ';
          } else {
            addressStr += ' ';
          }
        } else {
          if (this.selectedLead.person.county) {
            addressStr += this.selectedLead.person.county + ' ';
          }
        }

        if (this.selectedLead.person.postalCode) {
          addressStr += this.selectedLead.person.postalCode + ' ';
        }
      }
      return addressStr === '' || addressStr === ' ' ? 'N/A' : addressStr;
    },
    extractValue: function(healthParam) {
      if (this.selectedLead.values === null || this.selectedLead.values.length === 0) {
        return 'N/A';
      }
      const leadValues = this.selectedLead.values.flatMap(val => val.leadValues);
      const leadValue = leadValues.find(val => val.healthParam.id === healthParam.id);
      //const leadValue = this.selectedLead.values[0].leadValues.find(val => val.healthParam.id === healthParam.id)
      if (leadValue && leadValue.value !== '' && leadValue.value !== null && leadValue.value !== undefined && leadValue.value !== 'null') {
        let valueText = leadValue.value;
        if (healthParam.unit) valueText += ` ${healthParam.unit}`;
        return valueText;
      }

      return 'N/A';
    },
  },
  computed: {
    hiddenParams: function() {
      //hba1cRisk
      //hba1cRange
      //cholesterolRisk
      //cholesterolRange

      return ['hba1cRisk', 'hba1cRange', 'cholesterolRisk', 'cholesterolRange'];
    },
    isMobile: function() {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches;
    },
    headerTitle: function() {
      let header = '';
      header += `${this.selectedLead.person ? this.selectedLead.person.name ? this.selectedLead.person.name : 'N/A' : 'N/A'} - ${this.$options.filters.localTime(this.selectedLead.createdAt, 'YYYY-MM-DD HH:mm')}`;
      return header;
    },
    /*countries: function() {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === 'gb') {
          code = 'en';
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`));
      }
      let tempCountries = countries.getNames(Vue.i18n.locale().toLowerCase() === 'gb' ? 'en' : Vue.i18n.locale().toLowerCase());
      let countriesList = [];
      for (const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key,
        });
      }
      return countriesList;
    },*/
    countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        } else if (code.toLowerCase() === 'cz') {
          code = 'cs'
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let vueI18nLocale = Vue.i18n.locale().toLowerCase()
      switch (vueI18nLocale) {
        case 'gb':
          vueI18nLocale = 'en'
          break;
        case 'cz':
          vueI18nLocale = 'cs'
          break;
      }
      let tempCountries = countries.getNames(vueI18nLocale)
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
      //return CountryList.filter(country => this.$store.state.countries.allowed.includes(country.code))
      //return CountryList
    },
  },
};
</script>

<style scoped lang="scss">
.measurement-card {
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.left-div {
  height: 6.8em;
  width: 20%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.right-div {
  width: 80%;
  float: left;
}

.left-div, .right-div {
  padding: 10px;
  box-sizing: border-box;
}
</style>
